<div class="registration-with-code-qrcode-combined">

  <sc-flex vertical stretchContent>
    <sc-padding>
      <sc-title>
        <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.headline"></sc-dictionary-label>
      </sc-title>
    </sc-padding>

    <sc-flex stretchContent fitHeight>
      <sc-flex-fitting-content>
        <sc-padding>
          @if (!qrCodeScanEnabled) {
            <div>
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.description"></sc-dictionary-label>
            </div>
          }

          @if (qrCodeScanEnabled) {
            <div>
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.description-with-scanning"></sc-dictionary-label>
            </div>
          }

          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.headline"></sc-dictionary-label>
          </sc-sub-title>

          <form [formGroup]="registrationForm" class="form">
            <mat-form-field class="registration-code" appearance="fill">
              <mat-label>Code</mat-label>
              <input matInput #focusComponent formControlName="code" autofocus>
            </mat-form-field>
          </form>

          <app-service-response [responseMessages]="responseMessages"></app-service-response>
          @if (validationMessage != null) {
            <sc-sub-title>
              <sc-dictionary-label [dictionaryKey]="validationMessage.message"></sc-dictionary-label>
            </sc-sub-title>
            <sc-content-spacer vertical></sc-content-spacer>
          }
          @if (checkCodeActive) {
            <mat-spinner class="progressSpinner"></mat-spinner>
          }

        </sc-padding>
      </sc-flex-fitting-content>

      @if (qrCodeScanEnabled) {
        <div>
          <sc-padding>
            @if (scannerType != 'webcam') {
              <div class="qrcode">
                <img src="/assets/default/terminal_scan_qrcode_2.svg">
                <div class="diode">
                  <div class="laser"></div>
                </div>
              </div>
            }
            @if (scannerType === 'webcam' && webCamScannerEnabled) {
              <div class="qrcode">
                <zxing-scanner #scanner [enable]="webCamScannerEnabled"
                  [device]="deviceCurrent"
                  [autostart]="true"
                  (camerasFound)="camerasFoundHandler($event)"
                  (permissionResponse)="onCameraPermission($event)"
                  (deviceChange)="onCameraDeviceChanged($event)"
                  (scanSuccess)="scanSuccessHandler($event)"
                  (scanError)="scanErrorHandler($event)"
                (scanComplete)="scanCompleteHandler($event)"></zxing-scanner>
              </div>
            }
          </sc-padding>
        </div>
      }

    </sc-flex>

    @if (newRegistrationEnabled) {
      <div>
        <p>
          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.subline"></sc-dictionary-label>
        </p>
      </div>
    }

  </sc-flex>


</div>
